module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignature.4a6dbfc.jpg";